module.exports = __webpack_public_path__ + "img/202212021348496376kb.fc2a8f5f.jpg";